import React from 'react';
import { processSteps } from '../mock';
import { useLanguage } from '../context/LanguageContext';

const ApproachSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="approach" className="py-24 bg-white relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-100/50 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-100/50 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-yellow-400 text-gray-900 rounded-full text-sm font-bold mb-4">
            {t('approach.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span className="text-yellow-500">
              {t('approach.title')}
            </span>{' '}
            {t('approach.titleHighlight')}
          </h2>
        </div>

        {/* Process Steps */}
        <div className="space-y-8">
          {processSteps.map((step, index) => (
            <div
              key={step.number}
              className="group relative"
            >
              <div className="flex flex-col md:flex-row items-center gap-8">
                {/* Step Number Circle */}
                <div className="flex-shrink-0">
                  <div className="relative">
                    <div className="w-32 h-32 rounded-full bg-yellow-400 flex items-center justify-center shadow-2xl transform group-hover:scale-110 transition-all duration-300">
                      <span className="text-5xl font-bold text-gray-900">{step.number}</span>
                    </div>
                    {/* Connecting Line */}
                    {index < processSteps.length - 1 && (
                      <div className="hidden md:block absolute top-full left-1/2 transform -translate-x-1/2 w-1 h-24 bg-yellow-300"></div>
                    )}
                  </div>
                </div>

                {/* Step Content */}
                <div className="flex-1 bg-gray-50 rounded-2xl p-8 shadow-lg group-hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-1 border border-gray-100">
                  <h3 className="text-3xl font-bold text-gray-900 mb-4 group-hover:text-yellow-600 transition-colors">
                    {t(`approach.step${index + 1}.title`)}
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {t(`approach.step${index + 1}.description`)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;